import { render, staticRenderFns } from "./TrainingInfoStep.vue?vue&type=template&id=4b410083"
import script from "./TrainingInfoStep.vue?vue&type=script&lang=js"
export * from "./TrainingInfoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports